import React from 'react';
import { DIAMOND_EDUCATION_CONTENT } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const DiamondEducation = () => {
  const {
    hero,
    whatAreLabGrown,
    fourCs,
    comparison,
    certification,
    buyingMistakes,
    myths,
    faqs
  } = DIAMOND_EDUCATION_CONTENT;

  return (
    <main className="bg-[#FFFFFF] text-[#1a1a1a] selection:bg-[var(--brand-green-tint-bg)] selection:text-[var(--brand-green)] font-sans min-h-screen">

      {/* 1. HERO — THE COMPLETE DIAMOND GUIDE */}
      <section className="relative h-[45vh] min-h-[340px] lg:h-[62vh] hero-vh-45-62 overflow-hidden border-b border-[#EEF1E4]">
        <img
          src={hero.image}
          alt="House of Seya The Complete Diamond Guide"
          className="w-full h-full object-cover object-center filter-none opacity-100"
          style={{ filter: 'none', opacity: 1 }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/25 flex items-center justify-center">
          <div className="text-center text-white px-6 max-w-4xl mx-auto">
            <h1 className="font-serif text-3xl sm:text-5xl lg:text-7xl font-normal tracking-tight text-[var(--brand-cream)] leading-tight">
              The Complete Diamond Guide
            </h1>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE LAB-GROWN DIAMONDS? */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

            {/* Left Column: Asymmetric Image */}
            <div className="lg:col-span-7">
              <div className="aspect-[4/5] sm:aspect-[16/11] lg:aspect-[4/3] overflow-hidden bg-[#FFFFFF] border border-[#EEF1E4] shadow-sm relative group">
                <img
                  src={whatAreLabGrown.image}
                  alt={whatAreLabGrown.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 filter-none opacity-100"
                  style={{ filter: 'none', opacity: 1 }}
                />
              </div>
            </div>

            {/* Right Column: Editorial Text */}
            <div className="lg:col-span-5">
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal leading-tight">
                {whatAreLabGrown.title}
              </h2>
              <div className="w-12 h-px bg-[var(--brand-sage)] my-6 opacity-60" />
              <div className="space-y-5 text-sm sm:text-base text-[#5a5346] leading-relaxed font-sans">
                <p>{whatAreLabGrown.p1}</p>
                <p>{whatAreLabGrown.p2}</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 3. THE 4C'S OF DIAMONDS (MATCHING HOME EXPLORE BY CATEGORY CAROUSEL) */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal">
              The 4C's of Diamonds
            </h2>
            <p className="mt-4 text-sm sm:text-base text-[#5a5346] leading-relaxed font-sans">
              {fourCs.intro}
            </p>
          </div>

          {/* 4Cs Carousel matching Home CategoryGrid pattern */}
          <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide -mx-6 px-6 sm:mx-0 sm:px-0 items-stretch">
            {fourCs.items.map((item, idx) => (
              <div
                key={item.title}
                className="flex-shrink-0 w-full sm:w-auto snap-center bg-white border border-[#E5E7EB] p-6 sm:p-8 shadow-sm rounded-sm flex flex-col justify-between self-stretch hover:border-[var(--brand-sage)] transition-colors duration-300"
              >
                <div>
                  <span className="text-[11px] font-mono uppercase tracking-widest text-[var(--brand-green-tint-accent)] font-semibold block mb-2">
                    0{idx + 1} · {item.title}
                  </span>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a] font-normal mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#5a5346] leading-relaxed font-sans">
                    {item.body}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* 4. LAB-GROWN VS. NATURAL DIAMOND: A CLEAR COMPARISON */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal leading-tight">
              Lab-Grown vs. Natural Diamond: A Clear Comparison
            </h2>
          </div>

          {/* Comparison Carousel matching Home CategoryGrid pattern */}
          <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide -mx-6 px-6 sm:mx-0 sm:px-0 items-stretch">
            {comparison.rows.map((row) => (
              <div
                key={row.factor}
                className="flex-shrink-0 w-full sm:w-auto snap-center bg-white border border-[#E5E7EB] p-6 sm:p-8 shadow-sm rounded-sm flex flex-col justify-between h-full min-h-[310px] sm:min-h-[220px] hover:border-[var(--brand-sage)] transition-colors duration-300"
              >
                <div>
                  <h3 className="font-serif text-xl lg:text-2xl text-[#1a1a1a] font-normal mb-4">
                    {row.factor}
                  </h3>
                  <div className="space-y-4">
                    <div className="p-4 bg-[var(--brand-green-tint-bg)]/80 border-l-4 border-[var(--brand-green)] rounded-sm">
                      <span className="block text-[11px] font-mono text-[var(--brand-green)] font-medium mb-1 uppercase tracking-wider">
                        Lab-Grown Diamond
                      </span>
                      <p className="text-sm font-sans text-[var(--brand-green)] font-semibold">
                        {row.labGrown}
                      </p>
                    </div>
                    <div className="p-4 bg-white border border-[#EEF1E4] rounded-sm">
                      <span className="block text-[11px] font-mono text-[#999959] font-medium mb-1 uppercase tracking-wider">
                        Natural Mined Diamond
                      </span>
                      <p className="text-sm font-sans text-[#5a5346]">
                        {row.natural}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Concluding Statement Under Comparison Carousel */}
          <div className="mt-14 max-w-3xl mx-auto p-8 bg-[var(--brand-green-tint-bg)] border border-[var(--brand-green-border)] text-center">
            <p className="font-serif text-base sm:text-xl text-[var(--brand-green)] leading-relaxed font-normal italic">
              "{comparison.concluding}"
            </p>
          </div>

        </div>
      </section>

      {/* 5. UNDERSTANDING IGI CERTIFICATION */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

            {/* Left Column: Copy */}
            <div className="lg:col-span-6">
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal leading-tight">
                {certification.title}
              </h2>
              <div className="w-12 h-px bg-[var(--brand-sage)] my-6 opacity-60" />
              <div className="space-y-5 text-sm sm:text-base text-[#5a5346] leading-relaxed font-sans">
                <p>{certification.p1}</p>
                <p>{certification.p2}</p>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="lg:col-span-6">
              <div className="aspect-[4/5] sm:aspect-[16/11] lg:aspect-[4/3] overflow-hidden bg-white border border-[#EEF1E4] shadow-sm relative group">
                <img
                  src={certification.image}
                  alt={certification.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 filter-none opacity-100"
                  style={{ filter: 'none', opacity: 1 }}
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 6. WHAT IGI CERTIFIES & WHY IT MATTERS TO YOU */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal">
              What IGI Certifies & Why It Matters to You
            </h2>
          </div>

          {/* Certification Carousel matching Home CategoryGrid pattern */}
          <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide -mx-6 px-6 sm:mx-0 sm:px-0 items-stretch">
            {certification.rows.map((row) => (
              <div
                key={row.certifies}
                className="flex-shrink-0 w-full sm:w-auto snap-center bg-white border border-[#E5E7EB] p-6 sm:p-8 shadow-sm rounded-sm flex flex-col justify-between h-full min-h-[210px] sm:min-h-[160px] hover:border-[var(--brand-sage)] transition-colors duration-300"
              >
                <div>
                  <h3 className="font-serif text-xl lg:text-2xl text-[#1a1a1a] font-normal mb-3">
                    {row.certifies}
                  </h3>
                  <div className="border-t border-[#EEF1E4] pt-4 mt-2">
                    <span className="text-[11px] font-mono text-[var(--brand-green)] font-medium block mb-1 uppercase tracking-wider">
                      Why It Matters to You:
                    </span>
                    <p className="text-sm text-[#5a5346] leading-relaxed font-sans">
                      {row.matters}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Concluding Statement Under Certification Carousel */}
          <div className="mt-12 p-6 bg-[#FFFFFF] border border-[#E5E7EB] text-center max-w-3xl mx-auto shadow-sm">
            <p className="text-xs sm:text-sm text-[#5a5346] leading-relaxed font-sans">
              {certification.concluding}
            </p>
          </div>

        </div>
      </section>

      {/* 7. COMMON DIAMOND BUYING MISTAKES */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal">
              Common Diamond Buying Mistakes
            </h2>
          </div>

          {/* Buying Mistakes Carousel matching Home CategoryGrid pattern */}
          <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide -mx-6 px-6 sm:mx-0 sm:px-0 items-stretch">
            {buyingMistakes.items.map((item) => (
              <div
                key={item.num}
                className="flex-shrink-0 w-full sm:w-auto snap-center bg-white border border-[#E5E7EB] p-6 sm:p-8 shadow-sm rounded-sm flex gap-5 items-start h-full min-h-[220px] sm:min-h-[150px] hover:border-[var(--brand-sage)] transition-colors duration-300"
              >
                <span className="font-serif text-4xl lg:text-5xl text-[var(--brand-green-tint-accent)] opacity-40 font-normal leading-none select-none flex-shrink-0">
                  {item.num}
                </span>
                <div>
                  <p className="text-sm text-[#5a5346] leading-relaxed font-sans pt-1">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>



      {/* 8. COMMON MYTHS ABOUT LAB-GROWN DIAMONDS (REUSING STANDARD SITE ACCORDION) */}
      <section className="py-20 lg:py-28 border-b border-[#EEF1E4] bg-[#FFFFFF]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1a1a1a] font-normal">
              Common Myths About Lab-Grown Diamonds
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {myths.items.map((item, index) => (
              <AccordionItem
                key={index}
                value={`myth-${index}`}
                className="border-b border-[#D8CEB9] bg-transparent transition-colors duration-200"
              >
                <AccordionTrigger className="py-6 font-serif text-base sm:text-lg text-[#1a1a1a] font-normal hover:no-underline text-left">
                  <div className="flex items-start gap-4 pr-4">
                    <span className="font-mono text-xs px-2.5 py-1 bg-rose-100 text-rose-800 font-medium rounded-sm flex-shrink-0 mt-0.5">
                      Myth
                    </span>
                    <span className="leading-snug">
                      "{item.myth}"
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pt-2 text-xs sm:text-sm text-[#5a5346] leading-relaxed font-sans">
                  <div className="flex items-start gap-4 mt-2">
                    <span className="font-mono text-xs px-2.5 py-1 bg-[var(--brand-green-tint-bg)] text-[var(--brand-green)] font-medium rounded-sm flex-shrink-0 mt-0.5">
                      Reality
                    </span>
                    <p className="text-xs sm:text-sm text-[#5a5346] leading-relaxed font-sans">
                      {item.reality}
                    </p>
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* 9. FREQUENTLY ASKED QUESTIONS */}
      <section className="py-20 lg:py-28 bg-[#FFFFFF]">
        <div className="max-w-[800px] mx-auto px-6 lg:px-10">
          <div className="text-center mb-10">
            <h2 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a]">
              Frequently Asked Questions
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="border-b border-[#d8ceb9]"
              >
                <AccordionTrigger className="font-serif text-base lg:text-lg text-[#1a1a1a] py-5 hover:no-underline text-left">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14px] text-[#5a5346] leading-relaxed pb-5 font-sans">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

    </main>
  );
};

export default DiamondEducation;
